import { setImmediate } from './classes/set-immediate';
export function noop() {
}
export function EnumToString(values) {
    let string = '';
    for (let i = 0, l = values.length; i < l; i++) {
        if (i > 0) {
            string += (i === (l - 1)) ? ' or ' : ',';
        }
        string += `'${values[i]}'`;
    }
    return string;
}
export function StringMaxLength(input, maxLength) {
    if (maxLength < 3) {
        throw new RangeError(`Expected maxLength greater or equal to 3`);
    }
    return (input.length > maxLength)
        ? (input.substring(0, maxLength - 3) + '...')
        : input;
}
export function MathClosestTo(targetValue, ...values) {
    let closest = values[0];
    let closestDistance = Math.abs(values[0] - targetValue);
    let distance;
    for (let i = 1, l = values.length; i < l; i++) {
        distance = Math.abs(values[i] - targetValue);
        if (distance < closestDistance) {
            closest = values[i];
            closestDistance = distance;
        }
    }
    return closest;
}
export function IsObject(value) {
    return (typeof value === 'object') && (value !== null);
}
export function IsArray(value) {
    return Array.isArray(value);
}
export function IsIterable(value) {
    return IsObject(value)
        && (Symbol.iterator in value);
}
export function IsAsyncIterable(value) {
    return IsObject(value)
        && (Symbol.asyncIterator in value);
}
export function IsIterator(value) {
    return IsObject(value)
        && (typeof value.next === 'function');
}
export function IsNullOrUndefined(value) {
    return (value === null) || (value === void 0);
}
export function IsMap(value) {
    return (value instanceof Map);
}
export function ToIterable(value) {
    if (IsNullOrUndefined(value)) {
        throw new TypeError(`Cannot cast value to an Iterable`);
    }
    else if (Symbol.iterator in value) {
        return value;
    }
    else if (typeof value === 'object') {
        if (typeof value.next === 'function') {
            return function* () {
                const iterator = value;
                let result;
                while (!(result = iterator.next()).done) {
                    yield result.value;
                }
            }();
        }
        else {
            return Object.entries(value);
        }
    }
    else {
        throw new TypeError(`Cannot cast value to an Iterable`);
    }
}
export function ToIterator(value) {
    if (IsNullOrUndefined(value)) {
        throw new TypeError(`Cannot cast value to an iterable`);
    }
    else if (Symbol.iterator in value) {
        return value[Symbol.iterator]();
    }
    else if (typeof value === 'object') {
        if (typeof value.next === 'function') {
            return value;
        }
        else {
            return Object.entries(value)[Symbol.iterator]();
        }
    }
    else {
        throw new TypeError(`Cannot cast value to an Iterator`);
    }
}
export function ToMap(value) {
    if (IsNullOrUndefined(value)) {
        throw new TypeError(`Cannot cast value to a Map`);
    }
    else if (value instanceof Map) {
        return value;
    }
    else if (Symbol.iterator in value) {
        return new Map(Array.from(value));
    }
    else if (typeof value === 'object') {
        if (typeof value.next === 'function') {
            const map = new Map();
            const iterator = value;
            let result;
            while (!(result = iterator.next()).done) {
                map.set(result.value[0], result.value[1]);
            }
            return map;
        }
        else {
            return new Map(Object.entries(value));
        }
    }
    else {
        throw new TypeError(`Cannot cast value to a Map`);
    }
}
export function UntilDefined(callback, onDefined, count = 1) {
    if (count >= 0) {
        const value = callback();
        if (value === void 0) {
            setImmediate(() => {
                UntilDefined(callback, onDefined, count - 1);
            });
        }
        else {
            onDefined(value);
        }
    }
}
//# sourceMappingURL=helpers.js.map